<script>
export default {
  name: 'icon-zoom',
  props: {
    color: {
      default: () => {
        return 'white'
      },
      type: String,
    },
  },
}
</script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 0.75H12.3964L12.8232 1.17678L14.9458 3.29939L12.2338 5.99261L12.0558 6.16939L12.2332 6.34678L13.6532 7.76678L13.8306 7.94417L14.0074 7.76616L16.7006 5.05417L18.8232 7.17678L19.25 7.60355V7V1V0.75H19H13ZM0.75 7V7.60355L1.17678 7.17678L3.29939 5.05417L5.99261 7.76616L6.16939 7.94417L6.34678 7.76678L7.76678 6.34678L7.94417 6.16939L7.76616 5.99261L5.05417 3.29939L7.17678 1.17678L7.60355 0.75H7H1H0.75V1V7ZM7 19.25H7.60355L7.17678 18.8232L5.05417 16.7006L7.76616 14.0074L7.94417 13.8306L7.76678 13.6532L6.34678 12.2332L6.16939 12.0558L5.99261 12.2338L3.29939 14.9458L1.17678 12.8232L0.75 12.3964V13V19V19.25H1H7ZM19.25 13V12.3964L18.8232 12.8232L16.7006 14.9458L14.0074 12.2338L13.8306 12.0558L13.6532 12.2332L12.2332 13.6532L12.0558 13.8306L12.2338 14.0074L14.9458 16.7006L12.8232 18.8232L12.3964 19.25H13H19H19.25V19V13Z"
      fill="#00A5EE"
      stroke="#00A5EE"
      stroke-width="0.5"
    />
  </svg>
</template>
